import styled from 'styled-components'
import rnStyled from 'styled-components/native'
import { charcoal } from '@sukiai/components/lib/colors'

import closeButton from '../../../lib/assets/icons/closeButton.png'

const InvisibleContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  overflow-x: hidden;
`

const Container = styled.div`
  overflow-y: auto;
  min-width: 500px;
  width: 60vw;
  background: white;
  color: ${charcoal};
  z-index: 2000;
  border-radius: 5px 5px 0 0;
  height: 92vh;
`

const HeaderActions = styled.div`
  height: 50px;
  width: 108%;
  margin: -20px 0px 20px 0px;
  background-color: #f0f4ef;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 44px;

  h4 {
    font-weight: 600;
  }
`

const Button = styled.button.attrs({
  type: 'button'
})`
  font-family: "Open Sans";
  border: none;
  outline: none;
  padding: 0px;
  background: transparent;
  cursor: pointer;
  color: rgb(65, 117, 5);
  font-size: 16px;
  font-weight: 600;

  &:disabled {
    color: gray;
  }
`

const ScriptNameInput = styled.input`
  width: 60%;
  font-family: "Open Sans";
  cursor: ${(props) => (props.readOnly ? 'default' : 'cursor')};
  height: 40px;
  border-radius: 6px;
  background-color: ${(props) =>
    props.readOnly ? 'none' : 'rgba(0, 0, 0, 0.03)'};
  background: inherit;
  color: inherit;
  border: none;
  outline: none;
  margin: auto;
  margin-bottom: 8px;
  padding: 0 10px;
  text-align: center;
  font-size: 18px;

  &:focus::placeholder {
    color: transparent;
  }
`

const Body = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${(props) => (props.readOnly ? '30px 20px 20px 20px' : '20px')};
  height: 100%;
  box-sizing: border-box;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  position: relative;
`

const SectionOptions = styled.div`
  position: absolute;
  left: 0;
  width: 420px;
  border-radius: 4px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 350px;
  overflow: scroll;
  div {
    padding: 10px;
    width: 100%;

    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
  z-index: 9999;
`

const CloseModalButton = styled.img.attrs({
  src: closeButton
})`
  width: 30px;
  height: 30px;
  &:hover {
    cursor: pointer;
  }
  position: absolute;
  top: 0;
  right: 0;
  margin: 20px 30px 0px 0px;
`

const Platter = styled.div`
  width: 420px;
  border-radius: 5px;
  font-family: "Open Sans";
  padding: 10px;
  cursor: ${(props) => (props.readonly ? 'default' : 'pointer')};
  position: relative;
  margin-bottom: 8px;

  &:hover {
    background-color: ${(props) =>
      props.readonly ? 'none' : 'rgba(0, 0, 0, 0.03)'};
  }

  .label {
    margin: 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.75);
  }

  .section-name {
    font-size: 18px;
    color: #000000;
    margin: 0;
    margin-top: 5px;
    font-weight: 600;
  }

  .section-name.dark {
    font-size: 18px;
    color: white;
    margin: 0;
    margin-top: 5px;
    font-weight: 600;
  }
`

const SectionBlock = styled.div`
  position: relative;
  width: 100%;
`

const Divider = styled.div`
  position: absolute;
  bottom: 74px;
  width: 108%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.03);
`

const Footer = rnStyled.View`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin: auto 30px 0px 0px;
`

const ActionButton = rnStyled.TouchableOpacity`
  margin-right: ${(props) => (props.alignleft === 'true' ? 'auto' : 'none')};
  padding: ${(props) => props.padding || '0px'};
`

const ActionText = rnStyled.Text`
  font-family: 'Open Sans';
  padding: 0px 10px;
  border-radius: 4px;
  font-weight: 600;
  margin-left: 18px;
  font-size: 16px;
  cursor: pointer;
  color: ${(props) => (props.disabled === 'true' ? '#DCDCDC' : '#417505')};
  transition-duration: 0.5s;
`

const ScriptNameTip = styled.div`
  font-size: 14px;
  color: rgb(0, 0, 0, 0.5);
`

export {
  Body,
  Button,
  Footer,
  Divider,
  Platter,
  Container,
  ActionText,
  ActionButton,
  SectionBlock,
  ScriptNameTip,
  HeaderActions,
  SectionOptions,
  ScriptNameInput,
  CloseModalButton,
  InvisibleContainer
}
